













import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  ADD_TO_FAVORITES,
  FETCH_FAVORITE_VESSELS,
  IS_VESSEL_IN_FAVORITES,
  REMOVE_FROM_FAVORITES
} from '@/store/vessels';
import { SearchResultItem } from '@/types/SearchResultItem';
import { Vessel } from '@/types/entities/Vessel';
import { User } from '@/types/entities/User';
import { EntityWrapper } from '@/types/EntityWrapper';
import BookmarkIcon from '@/svg/bookmarks.svg';
import BookmarkFilledIcon from '@/svg/bookmarks-filled.svg';

@Component({
  components: { BookmarkIcon, BookmarkFilledIcon }
})
export default class VesselBookmark extends Vue {
  @Prop() public vessel: SearchResultItem<Vessel>;
  @Prop({ default: false }) public white: boolean;

  get user(): SearchResultItem<User> {
    return this.$store.state.users.profile;
  }

  get isInFavorites(): boolean {
    return this.$store.getters[IS_VESSEL_IN_FAVORITES](this.vessel);
  }

  protected toggle() {
    if (this.isInFavorites) {
      this.removeFromFavorites();
    } else {
      this.addToFavorites();
    }
  }

  protected addToFavorites() {
    this.$store
      .dispatch(ADD_TO_FAVORITES, { vesselId: this.vessel.id, userId: this.user.id })
      .then(() => this.$store.dispatch(FETCH_FAVORITE_VESSELS));
  }

  protected removeFromFavorites() {
    this.$store
      .dispatch(REMOVE_FROM_FAVORITES, this.vessel.id)
      .then(() => this.$store.dispatch(FETCH_FAVORITE_VESSELS));
  }
}
